<template>
  <div data-test-id="form-simplified-enrollment-welcome">
    <h2 :class="[brandClasses.heading, brandClasses.welcomeHeading]">
      <base-interpolator :content="$t.simplifiedEnrollment.welcomeHeading">
        <template #brandName>
          {{ $t.brandName }}
        </template>
      </base-interpolator>
    </h2>
    <p class="mt-4" :class="[brandClasses.description, brandClasses.welcomeDescription]">
      <slot name="description">
        <base-interpolator :content="$t.simplifiedEnrollment.welcomeDescription">
          <template #terms="{ args: [message] }">
            <vf-link target="_blank" to="/loyalty-terms">
              {{ message }}
            </vf-link>
          </template>
        </base-interpolator>
      </slot>
    </p>
    <div class="mt-6 space-y-2">
      <slot name="actions">
        <vf-button class="w-full" @click="emit('continue')">
          {{ $t.completeProfile }}
        </vf-button>
        <vf-button class="w-full" variant="secondary" @click="emit('cancel')">
          {{ $t.maybeLater }}
        </vf-button>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  cancel: []
  continue: []
}>()

const { brandClasses } = useAppConfig().components.dialog.simplifiedEnrollment
</script>
